module.exports = __webpack_public_path__ + "src/images/measurements/omitBustUnder.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/omitBustUnder.png
// module id = 1155
// module chunks = 0